import { useState } from "react";

const initialForm = {
  id: null,
  company_name: "",
  branch: "",
  brand: "",
  phone: "",
  sales_name: "",
  position: "",
  email: "",
  product_type: "",
  country_code: "+62",
};

export default function useVendorForm() {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [validated, setValidated] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!form.company_name.trim())
      newErrors.company_name = "Nama Perusahaan wajib diisi.";
    if (!form.branch.trim()) newErrors.branch = "Cabang wajib diisi.";
    if (!form.brand.trim()) newErrors.brand = "Merk wajib diisi.";
    if (!form.sales_name.trim())
      newErrors.sales_name = "Nama Sales wajib diisi.";
    if (!form.position.trim()) newErrors.position = "Jabatan wajib diisi.";
    if (!form.email.trim()) {
      newErrors.email = "Email wajib diisi.";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Format email tidak valid.";
    }
    if (!form.product_type.trim())
      newErrors.product_type = "Tipe Barang wajib diisi.";
    if (!form.phone) {
      newErrors.phone = "Nomor Telepon wajib diisi.";
    } else if (!/^[0-9]+$/.test(form.phone)) {
      newErrors.phone = "Nomor hanya boleh berisi angka.";
    } else if (form.phone.startsWith("0")) {
      newErrors.phone =
        "Nomor tidak boleh diawali dengan 0 (gunakan format tanpa 0).";
    } else if (form.phone.length < 7 || form.phone.length > 15) {
      newErrors.phone = "Nomor harus 7–15 digit.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const parsedValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setForm({
      ...form,
      [name]: parsedValue,
    });
  };

  const resetForm = () => {
    setForm(initialForm);
    setErrors({});
    setValidated(false);
  };

  return {
    form,
    setForm,
    errors,
    validated,
    setValidated,
    validate,
    handleChange,
    resetForm,
  };
}
